import * as yup from 'yup'

export const leaderApproveSchema = yup.object().shape({
    day_off_feedback_lead: yup.string().required('Please feedback'),
})
